import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createClient } from '@connectrpc/connect';
import { useQuery } from '@tanstack/react-query';
import { CheckoutService } from 'proto/gen/ts/shirt/v1/checkout_pb';
import { Link } from 'react-router-dom';
import { ROUTES } from '../routes';
import { formatPrice } from '../utils/format';
import { transport } from '../utils/transport';
const checkoutClient = createClient(CheckoutService, transport);
export default function OrderHistoryPage() {
    const { data, isLoading, isError } = useQuery({
        queryKey: [
            'myOrders'
        ],
        queryFn: ()=>checkoutClient.getMyOrders({})
    });
    if (isLoading) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 animate-pulse space-y-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "h-8 bg-stone-100 w-1/3 mb-8"
                }),
                [
                    1,
                    2,
                    3
                ].map((i)=>/*#__PURE__*/ _jsx("div", {
                        className: "h-20 bg-stone-50"
                    }, i))
            ]
        });
    }
    if (isError) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "font-display text-4xl text-stone-900 uppercase tracking-wide mb-4",
                    children: "My Orders"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-stone-500",
                    children: "Failed to load orders. Please try again later."
                })
            ]
        });
    }
    const orders = data?.orders ?? [];
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "font-display text-4xl text-stone-900 uppercase tracking-wide mb-8",
                children: "My Orders"
            }),
            orders.length === 0 ? /*#__PURE__*/ _jsxs("div", {
                className: "text-center py-12",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-stone-500 mb-6",
                        children: "You haven't placed any orders yet."
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        to: ROUTES.shop,
                        className: "inline-block bg-stone-900 text-white px-6 py-3 text-xs font-semibold uppercase tracking-wider",
                        children: "Start Shopping"
                    })
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: "space-y-4",
                children: orders.map((order)=>/*#__PURE__*/ _jsxs(Link, {
                        to: `/account/orders/${order.id}`,
                        className: "bg-white border-2 border-stone-100 p-4 block hover:border-stone-300 transition-colors",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("p", {
                                                className: "text-sm font-mono text-stone-600",
                                                children: [
                                                    order.id.slice(0, 8),
                                                    "..."
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-xs text-stone-400 mt-1",
                                                children: order.createdAt ? new Date(order.createdAt).toLocaleDateString() : ''
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-right",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "font-semibold text-stone-900",
                                                children: formatPrice(Number(order.totalCents))
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: `inline-block mt-1 px-2 py-0.5 text-xs font-semibold uppercase tracking-wider ${order.status === 'paid' ? 'bg-blue-100 text-blue-700' : order.status === 'cancelled' ? 'bg-red-100 text-red-700' : 'bg-stone-100 text-stone-600'}`,
                                                children: order.status
                                            })
                                        ]
                                    })
                                ]
                            }),
                            order.itemCount > 0 && /*#__PURE__*/ _jsxs("p", {
                                className: "text-xs text-stone-400 mt-2",
                                children: [
                                    order.itemCount,
                                    " item",
                                    order.itemCount !== 1 ? 's' : ''
                                ]
                            })
                        ]
                    }, order.id))
            })
        ]
    });
}
